module.exports = __webpack_public_path__ + "static/media/joshean_devin_a.e1cf1533.jpg";